export default __webpack_public_path__ + "static/media/cloth_06.3df3646b.jpg";